<template>
  <div class="page">
    <!-- TODO transiting between page types better -->
    <transition name="medium-fade">
      <place v-if="activePage && activePage.type === 'place'"/>
      <video-page v-if="activePage && activePage.type === 'video'"/>
      <card-grid-page v-if="activePage && activePage.type === 'card-grid'"/>
      <live v-if="activePage && activePage.type === 'live'"/>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Live from '@/views/Live'
import Place from '@/components/Place'
import VideoPage from '@/components/VideoPage'
import CardGridPage from '@/components/CardGridPage'

export default {
  name: 'page',

  components: { Live, Place, VideoPage, CardGridPage },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      activeProperties: 'property/activeProperties',
    })
  },
}
</script>
